import DefaultCell from "application/components/DefaultCell";
import formControl from "globals/form-control";

function getColorBox(value) {
  return (
    <div
      style={{
        backgroundColor: value,
        width: "30px",
        height: "30px",
        borderRadius: "50%",
      }}
    ></div>
  );
}
const getUpdateColumns = () => {
  return [
    {
      Header: "Department Code",
      accessor: "code",
      disabled: true,
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      isUserGenerated: true,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
    },
    {
      Header: "Department Name",
      accessor: "description",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      validation: formControl.string().required("Required").nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Contact Number",
      accessor: "contactNo",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      isUserGenerated: true,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Company",
      accessor: "companyCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "long",
      width: 6,
      isUserGenerated: true,
      controlType: "select",
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "code",
        keyDescription: "description",
        values: [],
        url: "/company/listAll",
      },
    },
    {
      Header: "Floor",
      accessor: "floor",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Emergency Contact Number",
      accessor: "emergencyContactNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Priority",
      accessor: "departmentPriority",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Color",
      accessor: "color",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "colorPicker",
      width: 6,
      Cell: ({ value }) => getColorBox(value),
    },
  ];
};

export { getUpdateColumns };
